import {css} from '@emotion/react'
import {NodePropertiesPane} from '../../SidePanel/RightPanel/NodePane.jsx'
import ButtonEditProduct from './PropertiesPaneButtonEditProduct.jsx'
import ProductSn from './PropertiesControllerProductSn.jsx'
import ProductStatus from './PropertiesControllerProductStatus.jsx'
import ProjectNumber from './PropertiesControllerProjectNumber.jsx'
import Version from './PropertiesControllerVersion/PropertiesControllerVersion.jsx'

const cssButtons = css({
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
})

export function ComponentPropertiesPane({
    controllers,
    projectNumber = <ProjectNumber />,
    snSuffix,
    sn = <ProductSn labelSuffix={snSuffix} />,
    versionLabel = '版本号',
    version = <Version label={versionLabel} />,
    ...props
}) {
    return (
        <PropertiesPane
            controllers={
                <>
                    {projectNumber}
                    {sn}
                    {version}
                    {controllers}
                </>
            }

            {...props}
        />
    )
}

export function ProductPropertiesPane({
    buttons,
    controllers,
    projectNumber = <ProjectNumber />,
    snSuffix,
    sn = <ProductSn labelSuffix={snSuffix} />,
    status = <ProductStatus />,
    versionLabel = '版本号',
    version = <Version label={versionLabel} />,
    ...props
}) {
    return (
        <PropertiesPane
            buttons={
                <>
                    <ButtonEditProduct />
                    {buttons}
                </>
            }

            controllers={
                <>
                    {projectNumber}
                    {sn}
                    {version}
                    {status}
                    {controllers}
                </>
            }

            {...props}
        />
    )
}

export function PropertiesPane({buttons, controllers, ...props}) {
    return (
        <NodePropertiesPane {...props}>
            {controllers}
            <div css={cssButtons}>{buttons}</div>
        </NodePropertiesPane>
    )
}
